import type { ArgoCDApplicationResource, ProjectResource } from "@octopusdeploy/octopus-server-client";
import { ExpandingTagList } from "~/areas/infrastructure/components/ArgoCDInstances/components/ExpandingTagList";
import { projectTagList } from "~/components/Tag";
type ArgoCDApplicationProjectsTagListProps = {
    application: ArgoCDApplicationResource;
    projects: ProjectResource[];
};
export const ArgoCDApplicationProjectsTagList = (props: ArgoCDApplicationProjectsTagListProps) => {
    const projectIds = [...new Set(props.application.Sources.map((src) => src.ProjectId).filter((id) => id !== null))];
    return <ExpandingTagList singularName={"project"} ids={projectIds} renderTagList={(ids) => projectTagList(props.projects, ids)}/>;
};
